import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
export const maxValidator = (max: number, message: string) => {
	return (AC: AbstractControl): ValidationErrors | null => {
		const isError = Validators.max(max)(AC);
		if (isError)
			return {
				max: max,
				actual: AC.value,
				message: message || `Max Value equals to ${max}`,
			};
		return null;
	};
};
